import {TrashIcon} from '@/components/svg/TrashIcon';
import {CatalogueModale} from '@/domains/article/NomenclatureModale/CatalogueModale';
import {AddIcon} from '@chakra-ui/icons';
import {HStack} from '@chakra-ui/layout';
import {Button} from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';
import {useTranslation} from 'react-i18next';

export const ProductControlSideHeader: React.FC<{
  deleteText?: string;
  deleteAction?: () => void;
  isDeleteDisabled?: boolean;
  onPlusDeProduitClick?: () => void;
}> = ({deleteText, deleteAction, isDeleteDisabled, onPlusDeProduitClick}) => {
  const {t} = useTranslation();
  deleteText ??= t('cadencier.retirer_des_produits');
  const handlePlusDeProduit = () => {
    if (onPlusDeProduitClick) {
      onPlusDeProduitClick();
    } else {
      NiceModal.show(CatalogueModale);
    }
  };

  return (
    <>
      {/* //MOBILE */}
      <HStack
        flexWrap='wrap'
        w='100%'
        gap='0'
        display={{base: 'flex', md: 'none'}}
      >
        <Button
          minW='min(fit-content, 50%)'
          flex='1'
          w='max-content'
          borderRadius='0'
          p='5'
          borderY='1px solid'
          borderX='0.5px solid'
          borderColor='gray.light'
          variant='ghost'
          leftIcon={<AddIcon />}
          onClick={handlePlusDeProduit}
        >
          {t('catalogue.plus_de_produit')}
        </Button>
        {deleteAction !== undefined && (
          <Button
            minW='min(fit-content, 50%)'
            flex='1'
            w='max-content'
            borderRadius='0'
            p='5'
            borderY='1px solid'
            borderX='0.5px solid'
            borderColor='gray.light'
            variant='ghost'
            leftIcon={<TrashIcon />}
            isDisabled={isDeleteDisabled}
            onClick={deleteAction}
          >
            {deleteText}
          </Button>
        )}
      </HStack>
      {/* //DESKTOP */}
      <HStack
        ml='auto'
        alignItems='center'
        spacing='0'
        display={{base: 'none', md: 'flex'}}
      >
        <Button
          maxW='100%'
          variant='ghost'
          fontSize='sm'
          px='0'
          leftIcon={<AddIcon />}
          onClick={handlePlusDeProduit}
        >
          {t('catalogue.plus_de_produit')}
        </Button>
        {deleteAction && (
          <Button
            variant='ghost'
            fontSize='sm'
            px='3'
            leftIcon={<TrashIcon />}
            isDisabled={isDeleteDisabled}
            onClick={deleteAction}
          >
            {deleteText}
          </Button>
        )}
      </HStack>
    </>
  );
};
